export const handleErrorResponse = (data, toast, navigate) => {
    if (data.code === 400) {
      switch (data.message) {
        case "You have reached the limit for drafts!":
          toast.error("You have reached the limit for drafts!");
          break;
        case "You have reached the limit of 8 events for this month!":
        toast.error("You have reached the limit of 8 events for this month!");
        break;
        case "Please subscribe first!":
          toast.error("Please subscribe first!");
          navigate("/dashboard/premium_plan");
          break;
        case "Your card printing limit has been exceeded!":
          toast.error("Your card printing limit has been exceeded!");
          navigate("/dashboard/premium_plan");
          break;
        default:
          toast.error("An error occurred. Please try again.");
      }
    }
  };

  // Separate function for success response
export const handleSuccessResponse = (status, eventOfRecipientId, toast, navigate) => {
    const isEdit = eventOfRecipientId && eventOfRecipientId.trim() !== "";
    const toastMessage =
      status === "draft"
        ? isEdit ? "Card Updated To Drafts" : "Card Saved To Drafts"
        : isEdit ? "Card Updated To Send To Print!" : "Card Saved To Send To Print!";
    toast.success(toastMessage);
  
    // Redirect based on status
    if (status === "draft") {
      // navigate("/dashboard/draft");
    } else {
      window.location.href = "/dashboard/print";
    }
  };